"use client"

import React, {useMemo, useState} from "react";
import {observer} from "mobx-react";
import styles from "../styles/userSettingsPageStyles.module.scss"
import classNames from 'classnames';
import dynamic from "next/dynamic";
import {useStores} from "../../stores/useStores";

const NotificationSettings = dynamic(() => import("./NotificationSettings"), {loading: () => <></>});
const FollowingView = dynamic(() => import("../../components/schoolfeed/FollowingView"), {loading: () => <></>});

export interface IUserWithSubscriptions extends Omit<IUser, "push_subscriptions"> {
    push_subscriptions: PushSubscription[]
}
const UserSettingsPage = observer((props: {
}) => {
    const {userStore, organizationStore} = useStores();
    const [currentView, setCurrentView] = useState("notificationSettings");

    const content = useMemo(() => {
        let c;
        if (currentView === "notificationSettings") {
            // personal notification settings
            c = <div className={styles.notificationSettings}>
                <NotificationSettings
                    setCurrentView={setCurrentView}
                />
            </div>;
        } else if (currentView === "following") {
            c = <div className={styles.notificationSettings}>
                <FollowingView
                />
            </div>
        }

        return c
    }, [
        currentView,
    ]);

    const displayContainerClassName = classNames({
        [styles.displayContainer]: true,
    });

    const optionsContainerClassName = classNames({
        [styles.optionsContainer]: true,
        [styles.optionsContainerBackgroundImage]: organizationStore.currentOrganization.backgroundImage,
    });

    return (
        <div className={displayContainerClassName} data-current-view={currentView}>
            <div className={styles.centerContainer}>
                <div className={optionsContainerClassName}>
                    {(userStore.id ) && <div className={styles.userDashboardButtons}>
                        <div>
                            <button disabled={currentView === "notificationSettings"}
                                    onClick={() => {setCurrentView("notificationSettings")}}>
                                Notifications
                            </button> |
                            <button disabled={currentView === "following"}
                                    onClick={() => {setCurrentView("following")}}>
                                Subscriptions
                            </button>
                        </div>
                    </div>}
                    {content}
                </div>
            </div>

        </div>
    );
})

export default UserSettingsPage;
